export default function ResourcesCTA() {
  return null;

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl py-10 sm:py-16">
        <div className="relative isolate overflow-hidden bg-ash-900 px-6 py-24 text-center shadow-2xl rounded-3xl sm:px-16">
          <h2 className="text-balance text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            Build Your Professional Website Today
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-ash-300">
            Get an SEO-optimized, mobile-ready website for your home service business in minutes. No upfront costs, no
            contracts, just results.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6 ">
            <a
              href="https://rebolthq.com"
              className="rounded-md bg-white px-3.5 py-2.5 text-sm no-underline font-semibold text-ash-900 shadow-xs hover:bg-ash-100 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Generate your website on Built Right"
            >
              Generate My Website
            </a>
          </div>
          <svg
            viewBox="0 0 1024 1024"
            aria-hidden="true"
            className="absolute left-1/2 top-1/2 -z-10 size-256 -translate-x-1/2 mask-[radial-gradient(closest-side,white,transparent)]"
          >
            <circle r={512} cx={512} cy={512} fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)" fillOpacity="0.7" />
            <defs>
              <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
                <stop stopColor="#FF5700" />
                <stop offset={1} stopColor="#802A00" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}
